<template>
    <div class="source-view">

        <section class="source-bg-img" v-for="(thumb, index) in renderList" @click="Preview22(thumb.src)">
            <div :style="{'background-image': 'url(' + thumb.ThumbUrl + ')'}">
                <img class="img-loaded-detect" :src="thumb.ThumbUrl" v-show="false" @load="$placeImg($event, 'parent')">
            </div>
        </section>

        <water-mark ref="watermark"></water-mark>

        <unauthorize v-if="callUnauthorize" :unauthorizeType="unauthorizeType"></unauthorize>

        <photo-package selector=".source-bg-img" :list="renderList" :options="options" @on-close="closeHandler" ref="sourcePreview">
        </photo-package>
    </div>
</template>


<script>
    import { SEARCH } from '@/api'
    import { wxPreviewImg } from '@/utils/wxPreviewImg';
    import WaterMark from '@/components/waterMark'
    import Unauthorize from '@/views/404/403'
    import PhotoPackage from 'photoswipe-package'
    export default {
        name: 'sourceView',
        data() {
            return {
                callUnauthorize: false,
                unauthorizeType: '401',
                options: {
                    loop: false,
                    zoomEl: true,
                    fullscreenEl: false,
                    tapToClose: true
                },
                renderList: []
            }
        },
        mounted() {
            this.initData()
        },
        methods: {
            initData() {
                if (this.sourceList) {  // 有vuex数据
                    this.$refs.watermark.initWaterMark()
                    this.renderList = this.sourceList
                    console.log(this.renderList)
                    this.setTitle()
                    return
                }
                if (this.$route.query.uuid) {
                    this.initRenderList()
                } else {
                    this.$store.commit('SetAndCallToast', '参数错误', 3000)
                    this.setTitle()
                }

                this.$refs.watermark.initWaterMark()
            },
            initRenderList() {
                SEARCH.GetKnowledgeDetail({
                    KBInfoId: this.$route.query.uuid,
                    width: 89,
                    height: 89
                }).then( (res) => {
                    if (res.Code == 401) {
                        this.unauthorizeType = '401'
                        this.callUnauthorize = true
                    } else if (res.Code == 404) {
                        this.unauthorizeType = '404'
                        this.callUnauthorize = true
                    } else if (res.Code == 200) {
                        let fileList = res.Data && res.Data.FileList.map( (file) => {
                            return {
                                src: file.FileUrl,
                                ThumbUrl: file.ThumbUrl,
                                FileType: file.FileType
                            }
                        })
                        this.renderList = fileList ? fileList.filter( (file) => {
                            return /jpg|jpeg|png/i.test(file.FileType)
                        }) : []
                        this.setTitle()
                    }
                })
            },
            setTitle() {
                document.title = this.renderList.length > 0 ? '所有照片(' + this.renderList.length + ')' : '所有照片'
            },
            Preview(index) {
                this.$refs.sourcePreview.show(index)
                this.$refs.watermark.initWaterMark(true)
            },
            Preview22(currUrl) {  // 换微信自带预览
                wxPreviewImg(currUrl, this.sourceUrlList)
            },
            closeHandler() {
                let timer = setTimeout( () => {
                    clearTimeout(timer)
                    this.$refs.watermark.initWaterMark()
                }, 300)
            }
        },
        computed: {
            sourceList() {
                return this.$store.getters.getSourceList
            },
            sourceUrlList() {  // 图片原图url列表
                return this.renderList.map( (item) => {
                    return item.src
                })
            }
        },
        activated() {
            this.initData()
        },
        components: { WaterMark, Unauthorize, PhotoPackage }
    }
</script>


<style lang="scss" scoped>
    .source-view {
        font-size: 0;
        margin-top: j(-6);
        margin-left: j(-6);
        padding: 0 j(10);
    }
    .source-bg-img {
        margin-top: j(6);
        margin-left: j(6);
        width: j(178);
        height: j(178);
        display: inline-block;
        background-color: #f5f5f5;
        background-image: url('/static/images/before_load.png');
        background-size: contain;
        div {
            height: 100%;
            opacity: 0;
            background-size: contain;
            background-repeat: no-repeat;
            transition: all 0.3s linear;
        }
    }
</style>




// WEBPACK FOOTER //
// src/views/sourceView.vue